import React from 'react';
import {
  Box,
  Button,
} from '@mui/material';
import ActionFooter from '../../../Shared/ActionFooter/ActionFooter';
import InspectionPanelList from './component/InspectionPanelList';
import VehicleNotIdentifiedModal from '../VehicleNotIdentifiedModal/VehicleNotIdentifiedModal';

const InspectionPanelNative = (props: any) => {
  const {
    goToNewInspection,
    showVehicleError,
    closeVehicleError,
  } = props;

  return (
    <Box component="div" className="inspection">
      <div className='title'>Painel de Vistorias</div>
      <div className='description'>Gerencie e acompanhe os status das suas vistorias.</div>
      <InspectionPanelList />
      <ActionFooter>
        <Button
          fullWidth
          variant="outlined"
          className="primary-button"
          onClick={goToNewInspection}
        >Realizar vistoria</Button>
      </ActionFooter>
      <VehicleNotIdentifiedModal
        open={showVehicleError}
        onClose={closeVehicleError}
      />
    </Box>
  );
};

export default InspectionPanelNative;
